import React from "react"
import icon from "images/icons/icon-plus.svg"

export default function PlusIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
